export default __webpack_public_path__ + "static/media/tomato_full.1f704d2f.png";